import Alert from "@mui/material/Alert";
import { PageContainer } from "core/components/PageContainer";
import { useTranslation } from "react-i18next";

export function Unauthorized401Page({
  alertMessage,
}: {
  alertMessage?: string;
}) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:Unauthorized401Page",
  });
  return (
    <PageContainer>
      {alertMessage && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {alertMessage}
        </Alert>
      )}
      <h1>{t("title")}</h1>
    </PageContainer>
  );
}
